var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 0.5C19.1602 0.5 20 1.33945 20 2.375C20 2.96484 19.7227 3.51953 19.25 3.875L10.75 10.25C10.3047 10.582 9.69531 10.582 9.25 10.25L0.75 3.875C0.277852 3.51953 0 2.96484 0 2.375C0 1.33945 0.839453 0.5 1.875 0.5H18.125ZM8.5 11.25C9.39063 11.918 10.6094 11.918 11.5 11.25L20 4.875V13C20 14.3789 18.8789 15.5 17.5 15.5H2.5C1.11914 15.5 0 14.3789 0 13V4.875L8.5 11.25Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.88838033d2be26724438b3d8bb7fa19b.svg";
export { ForwardRef as ReactComponent };